/* eslint-disable */
'use strict'
var Utils = {};
Utils.setCookie = function (name, value, days) {
  var Days = days ? days : 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";path=/;expires=" + exp.toGMTString();
}
Utils.getCooke = function (name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
};

export default Utils;



// WEBPACK FOOTER //
// ./src/utils/common.js